import { render, staticRenderFns } from "./UxIcon.vue?vue&type=template&id=559c2934&scoped=true"
import script from "./UxIcon.vue?vue&type=script&lang=ts"
export * from "./UxIcon.vue?vue&type=script&lang=ts"
import style0 from "./UxIcon.vue?vue&type=style&index=0&id=559c2934&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c2934",
  null
  
)

export default component.exports